export default __webpack_public_path__ + "static/media/GPA_Banner_News.bfa08d29.jpg";